import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Drawer from '@mui/material/Drawer';
import { COLORS } from '../../styles/theme';
import { SettingsRoute } from '../../types/settings';

const drawerWidth = 250;

export interface SideBarProps {
  routes: Array<SettingsRoute>;
  onSidebarChanged?: (key: string) => void;
}

export const SettingsSidebar = ({ routes, onSidebarChanged }: SideBarProps) => {
  const [offset, setOffset] = useState<number | null>(null);
  const StyledDrawer = styled(Drawer)(() => ({
    width: drawerWidth,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: drawerWidth,
      top: offset !== null ? offset : 100,
      left: '25px',
      border: 'none',
      height: 'auto',
    },
  }));

  const StyledBarOuter = styled('div')(() => ({
    padding: '0px 20px',
  }));

  const StyledHead = styled('h5')(() => ({
    marginBottom: '5px',
    marginTop: '15px',
    fontWeight: 'bold',
  }));

  const StyledList = styled(List)(() => ({
    marginBottom: '10px',
  }));

  const StyledListItem = styled(ListItem, {
    shouldForwardProp: prop => prop !== 'active',
  })<{ active?: boolean }>(({ active }) => ({
    padding: '0px',
    margin: '10px 0px 0px 0px',
    fontSize: '.85rem',
    color: active ? COLORS.PRIMARY_BLUE : '#000',
    background: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: COLORS.PRIMARY_BLUE,
    },
  }));

  const setSidebarHeight = () => {
    const header = document.querySelector('header');
    const headerHeight = header ? header.offsetHeight + 25 : 100;
    if (window.pageYOffset === 0) {
      setOffset(headerHeight);
    } else if (window.pageYOffset > 0 && window.pageYOffset < headerHeight) {
      const offst = document.querySelector('#settingsmain');
      if (offst) {
        setOffset(offst.getBoundingClientRect().top);
      }
    } else {
      setOffset(2);
    }
  };

  useEffect(() => {
    window.onresize = () => {
      setSidebarHeight();
    };
    window.onscroll = () => {
      setSidebarHeight();
    };
  }, []);
  const sidebarEvent = (key: string) => {
    routes.forEach(route => {
      if (route.key === key) {
        route.active = true;
      } else {
        route.active = false;
      }
    });
    if (onSidebarChanged) {
      onSidebarChanged(key);
    }
  };
  return (
    <StyledDrawer variant="permanent" anchor="left">
      <StyledBarOuter>
        <StyledHead>My Profile & Settings</StyledHead>
        <StyledList>
          {routes.map(route => (
            <StyledListItem
              key={route.key}
              active={route.active}
              onClick={() => sidebarEvent(route.key)}
              data-testid={route.key}
            >
              {route.text}
            </StyledListItem>
          ))}
        </StyledList>
      </StyledBarOuter>
    </StyledDrawer>
  );
};
